<template>
    <div class="custom-tree-container">

      <el-row class="content-bottom-padded" style="padding-top:15px;margin-left:20px">
          
          
        <el-col :md="8" :lg="5">
          <el-input placeholder="货号" v-model="params.item_bn" clearable>
            <el-button slot="append" icon="el-icon-search" @click="getPriceReviewList"></el-button>
          </el-input>
        </el-col>
         
      </el-row>
      <el-button size="small" type="primary" @click="reviewPriceDo(1)">审核全部通过</el-button>

      <el-table :data="reviewList"  v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="item_name" label="商品名" width="100"></el-table-column>
      <el-table-column prop="item_bn" label="商品货号" width="120"></el-table-column>
      <el-table-column prop="min_activity_price" label="活动价" width="100" >
          <template slot-scope="scope">
            {{scope.row.min_activity_price/100}}
          </template>
      </el-table-column>
       <el-table-column prop="market_price"  label="市场价" width="100" >
           <template slot-scope="scope">
            {{scope.row.market_price/100}}
           </template>
       </el-table-column>
      <el-table-column prop="start_time" label="开始时间" width="100">
        <template slot-scope="scope">
          {{scope.row.start_time| datetime('yyyy-MM-dd hh:mm')}}
         </template>
      </el-table-column>
      <el-table-column prop="end_time" label="结束时间" width="100">
        <template slot-scope="scope">
          {{scope.row.end_time| datetime('yyyy-MM-dd hh:mm')}}
         </template>
      </el-table-column>
      <el-table-column prop="upload_user" label="上传人员" width="100"></el-table-column>
      <el-table-column prop="upload_time" label="上传时间" width="100">
        <template slot-scope="scope">
        {{scope.row.upload_time| datetime('yyyy-MM-dd hh:mm')}}
         </template>
      </el-table-column>
      <el-table-column prop="review_user" label="审核人员" width="100"></el-table-column>
      <el-table-column prop="review_time" label="审核时间" width="230">
        <template slot-scope="scope">
          {{scope.row.review_time| datetime('yyyy-MM-dd hh:mm')}}
         </template>
      </el-table-column>
      <el-table-column prop="review_status" label="审核状态" width="100">
        <template slot-scope="scope">
          <el-tag  v-if="scope.row.review_status == '0'" >待审核</el-tag>
          <el-tag type="success" v-if="scope.row.review_status == '1'" >通过</el-tag>
          <el-tag type="danger" v-if="scope.row.review_status == '2'" >拒绝</el-tag>
         </template>
      </el-table-column>

      <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button  type="success" class=""  @click="reviewPriceDoOne(scope.row.id,1)">
              审核通过
            </el-button>
            <el-button type="danger" class=""  @click="reviewPriceDoOne(scope.row.id,2)">
              审核拒绝
            </el-button>
          </template>
        </el-table-column>
     
      </el-table>

      <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.pageSize">
     </el-pagination>
   </div>
      <el-dialog title="模板格式 文件名称格式x年x月x日商品审核.xlsx" :visible.sync="dialogS">
        <div class="content-center">
          <img :src="tempImg">
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="hideTmp">下载模板</el-button>
        </span>
      </el-dialog>
    </div>
    
     
</template>
<script>
  import { mapGetters } from 'vuex'
  import {getPriceReviewList,reviewPriceDo,reviewPriceDoList,reviewUpload} from '@/api/goods';



  export default {
    
    data() {
      return {
        tempImg:'https://b-img-cdn.yaoking.cn/1/2023/06/19/af8a2ee434f9e61f2cca20e46025d4d6mDsjRtAaesUBLZXEAvClrNP1SAGgAtlY',
        dialogS:false,
        isDisable: false,
        loading: false,
        spaceInput: false,
        categoryList: [],
        total_count: 0,
        title_id:'',
        params:{
          item_bn: '',
          title_id: '',
          page: 1,
          pageSize: 20,
        },
        imgDialog: false,
        isGetImage: true,
        current: '',
        category_id: '',
        show_batchStore: false,
        submitLoading: false,
        batchsubmitLoading:false,
        districtId:0,
        updateBatchList:[],
        shop_type_list: [],
        reviewList:[],
        itemstore: 0,
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      showTempImg()
      {
        this.dialogS = true
      },
      hideTmp()
      {
        this.dialogS = false
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getPriceReviewList()
      },
      
      getPriceReviewList(){
        
        getPriceReviewList(this.params).then(response => {
          this.reviewList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
        
      },
     
      reviewPriceDoOne(id,status)
      {

        let status_var = '是否通过, 是否继续?'
        if(status == '2'){
          status_var = '是否拒绝, 是否继续?'
        }
        this.$confirm(status_var, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          reviewPriceDo({id:id,status:status}).then(response=>{
          let status = response.data.data.status
          var messInfo = status ? '操作成功' : '操作失败';
          var typeMes  = status ? 'success' : 'error';
          this.$message({
            type: typeMes,
            message: messInfo
          });
          })
          this.getPriceReviewList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
        
      },

      reviewPriceDo(status)
      {

        let status_var = '是否通过, 是否继续?'
        if(status == '2'){
          status_var = '是否拒绝, 是否继续?'
        }
        let title_id = this.title_id
        this.$confirm(status_var, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          reviewPriceDoList({title_id:title_id,status:status}).then(response=>{
          let status = response.data.data.status
          var messInfo = status ? '操作成功' : '操作失败';
          var typeMes  = status ? 'success' : 'error';
          
          this.$message({
            type: typeMes,
            message: messInfo
            });
          })
          
          this.getPriceReviewList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })  
      },
    
    
      append(data, level = 0) {
        const newChild = {category_name: '', sort: 0, level: ++level, children: [], created: 0, image_url: ''}
        data.push(newChild)
      },
      appendTop(data) {
        const newChild = {category_name: '', sort: 0, level: 0, children: [], created: 0, image_url: ''}
        data.push(newChild)
      },
      
      handleImgChange(data) {
        this.imgDialog = true
        this.isGetImage = true
        this.current = data
      },
      
      closeImgDialog() {
        this.imgDialog = false
      },
    },

    mounted() { 
      if (this.$route.query.id) {
          this.title_id = this.$route.query.id
          this.params.title_id = this.$route.query.id
          this.getPriceReviewList();
      }
     
    }
  };
</script>

<style scoped lang="scss">
    .custom-tree-container {
        background-color: #fff;
        min-width: 1100px;
    }

    .tree-background {
        padding-bottom: 45px;
        margin: 0px 20px;
    }

    .custom-tree-node, .custom-tree-node-title {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        /*padding-right: 8px;*/
        li {
            display: inline-block;
            text-align: center;
            width: 25%;
        }

        li:first-child {
            text-align: left;
        }

        li.category-icon {
            display: flex;
            align-items: middle;
            justify-content: center;

            span {
                height: 30px;
            }

            img {
                width: auto;
                height: 30px;
            }
        }
    }

    .custom-tree-node-title {
        font-weight: bold;
        color: #909399;
        margin: 0px 20px;

        li {
            padding: 12px 0;
        }
    }

    .add-category {
        margin-left: 25px;
        margin-top: 30px;

        span {
            cursor: pointer;
        }
    }

    .remove-category {
        margin-left: 10px;
    }

    .add-child-category {
        margin-left: 10px;
    }
</style>
<style lang="scss">
    .custom-tree-container {
        .el-tree-node__content {
            height: 45px;
            padding: 0px;
            line-height: 45px;
        }

        .el-tree > .el-tree-node {
            position: relative;

            &::after {
                position: absolute;
                height: 1px;
                left: 0;
                right: 0;
                bottom: 0;
                content: "";
                background-color: #e6e6e6;
            }
        }

        .el-tree > .el-tree-node:first-child {
            &::before {
                position: absolute;
                height: 1px;
                left: 0;
                right: 0;
                top: 0;
                content: "";
                background-color: #e6e6e6;
            }
        }
    }

    .custom-tree-node {
        input {
            border: 1px solid #ddd;
            line-height: 25px;
            padding-left: 5px;
            width: 150px;
        }
    }

</style>



// WEBPACK FOOTER //
// priceviewlist.vue?706715db